import type { WithId } from '@octopus-do/octopus-project-core'
import type React from 'react'
import { Link } from 'react-router-dom'

import { clsJoin } from '@/utils'
import { FolderLinkCls } from './constants'
import css from './styles.module.css'

interface Props extends React.PropsWithChildren {
  folderId: string
  title: string
  activeFolder: string | null
  workspace: WithId
}

export const FolderLink: React.FC<Props> = ({
  folderId,
  children,
  activeFolder,
  title,
  workspace,
}) => {
  const active = activeFolder === folderId
  // todo: fix after routing release
  const url = `/dashboard/${workspace.id}/${folderId}`

  return (
    <Link
      to={url}
      className={clsJoin(FolderLinkCls.wrapper, active && css.active)}
    >
      <div className={FolderLinkCls.icon}>{children}</div>
      <div className={FolderLinkCls.text}>
        <div className={FolderLinkCls.title}>{title}</div>
      </div>
    </Link>
  )
}
